/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useCallback, useRef } from 'react';
import { IconButton, TextField } from '@mui/material';

import { ReactComponent as SearchIcon } from '../../assets/images/SearchIcon.svg';

/**
 * It's a custom text field that takes in props and returns a text field with a search icon.
 * @param {object} props - props accept all that support in TextField
 * @returns {JSX.Element} A React component.
 * @example <TransperentSearchBox placeholder="Search" />
 */
const TransperentSearchBox = (props) => {
  const liveRegionRef = useRef(null);

  /**
   * @function handleFocus
   * Handles focus event by setting the live region text to the aria-label when focused.
   */
  const handleFocus = useCallback(() => {
    if (liveRegionRef.current && props['aria-label']) {
      liveRegionRef.current.innerText = props['aria-label'];
    }
  }, [props['aria-label']]); // Dependencies: only changes when aria-label changes

  /**
   * @function handleBlur
   * Handles blur event by clearing the live region text when focus is lost.
   */
  const handleBlur = useCallback(() => {
    if (liveRegionRef.current) {
      liveRegionRef.current.innerText = '';
    }
  }, []); // No dependencies, runs only on blur

  return (
    <>
      <TextField
        // eslint-disable-next-line no-unused-vars
        sx={(theme) => ({
          backgroundColor: 'white',
          opacity: 0.8,
          padding: '0px',
          width: '200px',
          marginTop: '0px',
          borderRadius: '4px',
          // border: `1px solid ${theme.palette.other.grey5}`,
          // '&:focus': {
          //   border: `2px solid ${theme.palette.primary.main} !important`,
          // },
        })}
        variant="outlined"
        InputProps={{
          'aria-label': props['aria-label'], // Ensure aria-label is set
          'aria-describedby': props['aria-describedby'], // Provide additional context if needed
          sx: {
            backgroundColor: 'transparent !important',
            paddingLeft: 1,
            '& .MuiFilledInput-input': {
              paddingTop: '10px',
              '::placeholder': {
                color: 'text.placeholder',
                opacity: 1,
              },
            },
          },
          startAdornment: (
            <IconButton
              size="small"
              aria-hidden="true"
              tabIndex={-1}
              role="img"
            >
              <SearchIcon />
            </IconButton>
          ),
        }}
        onFocus={handleFocus}
        onBlur={handleBlur}
        {...props}
      />
      {/* Live region for screen reader announcements */}
      <div
        ref={liveRegionRef}
        role="alert"
        aria-live="assertive"
        style={{
          width: '0px',
          height: '0px',
          overflow: 'hidden',
        }}
      />
    </>
  );
};

export default TransperentSearchBox;
